import { render, staticRenderFns } from "./CuentasAYB.vue?vue&type=template&id=610d2e2b&scoped=true"
import script from "./CuentasAYB.vue?vue&type=script&lang=js"
export * from "./CuentasAYB.vue?vue&type=script&lang=js"
import style1 from "./CuentasAYB.vue?vue&type=style&index=1&id=610d2e2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610d2e2b",
  null
  
)

export default component.exports